import _ from 'lodash';
import { createSelector } from 'reselect';

import { getEntityByName } from '../appEntities';
import {
    COST_SCHEDULE_FAILURE,
    COST_SCHEDULE_LOAD,
    COST_SCHEDULE_SUCCESS
} from './billingActions';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case COST_SCHEDULE_LOAD:
            newState = {
                ...state,
                costSchedule: null,
                error: null,
                loading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case COST_SCHEDULE_SUCCESS:
            newState = {
                ...state,
                costSchedule: action.costSchedule,
                error: null,
                loading: false
            };

            return _.isEqual(state, newState) ? state : newState;

        case COST_SCHEDULE_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false
            };

            return _.isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getBillingEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'billing')
);

export const getCostSchedule = createSelector(
    getBillingEntity,
    (entity) => _.get(entity, 'costSchedule')
);
